import api from 'api';

const profileUrl = '/api/forget-me/user/:id';

export default {
    forgetMe: userid => api.get({path: profileUrl.replace(':id', userid)})
}